module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Git#4-5280cd9b47920d2246fcc4117e14fd23.svg";